/**
 * @file: useTimelineSummary.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useAsyncTaskResource } from '@euler/app/flows/task/functions/useTaskResource';
import { useServiceFactory } from '@euler/services/factory';
import { usePersistFn } from '@euler/utils/hooks';
import { useFocusEffect } from '@react-navigation/native';
import { useRef } from 'react';

export const getTimelineSummaryResourceId = (taskNo: string) => {
  return `tasks/${taskNo}/timeline:summary`;
};

export const useTaskTimelineSummary = (limit = 25) => {
  const { taskService } = useServiceFactory();
  const { detail } = useTaskContext();
  const lastVersion = useRef<number>(detail.version);
  const fetch = usePersistFn((taskNo: string) => {
    return taskService.getTaskTimeline(taskNo, limit);
  });

  const { value, refresh } = useAsyncTaskResource({
    resourceId: getTimelineSummaryResourceId,
    fetch,
  });

  useFocusEffect(() => {
    if (detail.version === lastVersion.current) return;
    lastVersion.current = detail.version;
    refresh();
  });

  return value;
};
